/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Month } from '../models/month';
import { StatementReportItem } from '../models/statement-report-item';


/**
 * Reports API.
 */
@Injectable({
  providedIn: 'root',
})
export class ReportsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation reportTransactionReport
   */
  static readonly ReportTransactionReportPath = '/v1/admin/billing/report/transaction-report';

  /**
   * Get transaction report.
   *
   * Returns list of transactions with fees data grouped by category
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportTransactionReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportTransactionReport$Response(params?: {
    MerchantIds?: Array<number>;
    StartDate?: string;
    EndDate?: string;
    MerchantProcessorIds?: Array<number>;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ReportsService.ReportTransactionReportPath, 'get');
    if (params) {
      rb.query('MerchantIds', params.MerchantIds, {"style":"form","explode":true});
      rb.query('StartDate', params.StartDate, {});
      rb.query('EndDate', params.EndDate, {});
      rb.query('MerchantProcessorIds', params.MerchantProcessorIds, {"style":"form","explode":true});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Get transaction report.
   *
   * Returns list of transactions with fees data grouped by category
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reportTransactionReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportTransactionReport(params?: {
    MerchantIds?: Array<number>;
    StartDate?: string;
    EndDate?: string;
    MerchantProcessorIds?: Array<number>;
  }): Observable<Blob> {

    return this.reportTransactionReport$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation reportFundingReport
   */
  static readonly ReportFundingReportPath = '/v1/admin/billing/report/funding-report';

  /**
   * Get funding report.
   *
   * Returns list of funding instructions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportFundingReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportFundingReport$Response(params?: {
    MerchantIds?: Array<number>;
    StartDate?: string;
    EndDate?: string;
    MerchantProcessorIds?: Array<number>;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ReportsService.ReportFundingReportPath, 'get');
    if (params) {
      rb.query('MerchantIds', params.MerchantIds, {"style":"form","explode":true});
      rb.query('StartDate', params.StartDate, {});
      rb.query('EndDate', params.EndDate, {});
      rb.query('MerchantProcessorIds', params.MerchantProcessorIds, {"style":"form","explode":true});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Get funding report.
   *
   * Returns list of funding instructions
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reportFundingReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportFundingReport(params?: {
    MerchantIds?: Array<number>;
    StartDate?: string;
    EndDate?: string;
    MerchantProcessorIds?: Array<number>;
  }): Observable<Blob> {

    return this.reportFundingReport$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation reportStatementReports
   */
  static readonly ReportStatementReportsPath = '/v1/admin/billing/report/by-merchant/{merchantId}/statement-reports/{id}';

  /**
   * Get statement report by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportStatementReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportStatementReports$Response(params: {
    merchantId: number;
    id: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ReportsService.ReportStatementReportsPath, 'get');
    if (params) {
      rb.path('merchantId', params.merchantId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Get statement report by ID.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reportStatementReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportStatementReports(params: {
    merchantId: number;
    id: string;
  }): Observable<Blob> {

    return this.reportStatementReports$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation reportStatementReportsAll
   */
  static readonly ReportStatementReportsAllPath = '/v1/admin/billing/report/by-merchant/{merchantId}/statement-reports/{year}/{month}';

  /**
   * Get statement report by date.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportStatementReportsAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportStatementReportsAll$Response(params: {
    merchantId: number;
    year: number;
    month: Month;
  }): Observable<StrictHttpResponse<Array<StatementReportItem>>> {

    const rb = new RequestBuilder(this.rootUrl, ReportsService.ReportStatementReportsAllPath, 'get');
    if (params) {
      rb.path('merchantId', params.merchantId, {});
      rb.path('year', params.year, {});
      rb.path('month', params.month, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<StatementReportItem>>;
      })
    );
  }

  /**
   * Get statement report by date.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reportStatementReportsAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportStatementReportsAll(params: {
    merchantId: number;
    year: number;
    month: Month;
  }): Observable<Array<StatementReportItem>> {

    return this.reportStatementReportsAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<StatementReportItem>>) => r.body as Array<StatementReportItem>)
    );
  }

  /**
   * Path part for operation reportFundingReconciliation
   */
  static readonly ReportFundingReconciliationPath = '/v1/admin/billing/report/funding-reconciliation';

  /**
   * Get funding reconciliation report.
   *
   * Returns funding reconciliation for the MID and date. Contains the list of amounts with difference between Exchange
   * and VituPay data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportFundingReconciliation()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportFundingReconciliation$Response(params?: {
    merchantId?: number;
    MerchantProcessorId?: number;
    CreatedDate?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ReportsService.ReportFundingReconciliationPath, 'get');
    if (params) {
      rb.query('merchantId', params.merchantId, {});
      rb.query('MerchantProcessorId', params.MerchantProcessorId, {});
      rb.query('CreatedDate', params.CreatedDate, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Get funding reconciliation report.
   *
   * Returns funding reconciliation for the MID and date. Contains the list of amounts with difference between Exchange
   * and VituPay data
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reportFundingReconciliation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportFundingReconciliation(params?: {
    merchantId?: number;
    MerchantProcessorId?: number;
    CreatedDate?: string;
  }): Observable<Blob> {

    return this.reportFundingReconciliation$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation reportDetailedFeeReconciliationReport
   */
  static readonly ReportDetailedFeeReconciliationReportPath = '/v1/admin/billing/report/detailed-fee-reconciliation-report';

  /**
   * Provides detailed fee reconciliation report.
   *
   * Use endpoint for debugging any problems with fees
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportDetailedFeeReconciliationReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportDetailedFeeReconciliationReport$Response(params?: {

    /**
     * Merchant id
     */
    merchantId?: number;
    Year?: number;
    Month?: number;
    Mid?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ReportsService.ReportDetailedFeeReconciliationReportPath, 'get');
    if (params) {
      rb.query('merchantId', params.merchantId, {});
      rb.query('Year', params.Year, {});
      rb.query('Month', params.Month, {});
      rb.query('Mid', params.Mid, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Provides detailed fee reconciliation report.
   *
   * Use endpoint for debugging any problems with fees
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reportDetailedFeeReconciliationReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportDetailedFeeReconciliationReport(params?: {

    /**
     * Merchant id
     */
    merchantId?: number;
    Year?: number;
    Month?: number;
    Mid?: string;
  }): Observable<Blob> {

    return this.reportDetailedFeeReconciliationReport$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
